import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { FleetView, fleetSearchShape } from "../../components/transport-fleet";
import { useDefaultGamesId } from "../../lib/competition/games";
import { canSeeFleet } from "../../lib/transport/access";

/** Drivers & vehicles (S5's `FleetView`): the dispatch desk writes, a provider reads its own fleet. */
export const Route = createFileRoute("/_app/logistics/transportation/fleet")({
	validateSearch: z.object(fleetSearchShape),
	beforeLoad: ({ context }) => {
		if (!canSeeFleet(context.session)) throw redirect({ to: "/logistics/transportation" });
	},
	component: FleetPage,
});

function FleetPage() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const gamesId = useDefaultGamesId(search.games_id);
	if (!gamesId) return <div className="skeleton h-[20rem] rounded-[0.625rem]" aria-busy />;
	return <FleetView session={session} gamesId={gamesId} search={search} navigate={navigate} />;
}
